const emissionsPoolNames = {
  intermediate: 'Intermediate',
  handy: 'Handy',
  mr: 'MR',
  lr2: 'LR2',
  lr1: 'LR1',
  city: 'City',
  flexi: '',
  panamax: 'Panamax',
  suezmax: 'Suezmax',
  aframax: 'Afra',
  'chemicals 1': '',
  'chemicals 2': 'Chemicals 2',
  'chemicals 3': '',
  'chemicals 4': '',
}

const reportsPoolNames = {
  ...emissionsPoolNames,
  flexi: 'Flexi',
}

export function getPowerBiPoolName(pool: string): string | undefined {
  if (!pool) {
    return undefined
  }
  const poolName = pool.toLowerCase() as keyof typeof reportsPoolNames

  // the powerBI pool names will be aligned across the reports in
  // https://maersktankers.atlassian.net/browse/PPW-3622
  // once done the below check will be removed
  const isEmissionsPage = window.location.pathname.includes('emission-universe')

  if (isEmissionsPage) {
    return emissionsPoolNames[poolName]
  }

  return reportsPoolNames[poolName]
}
